import SiteEnum from '@models/enums/SiteEnum';
import PageBreadcrumb, {
  PageBreadcrumbProps,
} from '@molecules/PageBreadcrumb/PageBreadcrumb';

const Breadcrumb = (props: PageBreadcrumbProps) => (
  <PageBreadcrumb {...props} site={SiteEnum.B2B} />
);

export default Breadcrumb;
